<template>
  <div class="border border-orange-50 box-shadow px-6 py-4 rounded user-security">
    <h1 class="font-medium mb-4 text-black">帳戶安全</h1>
    <div class="flex items-center sm:flex-col sm:items-start">
      <label class="sm:mb-2 text-gray-500 weiby-label-width">
        變更密碼
      </label>
      <w-button
        class="
          border-white
          hover:bg-white
          hover:border
          hover:border-primary-500
          hover:text-primary-500
          py-2
          sm:border-primary-500
          sm:w-full
          text-primary-500
        "
        variant="outline"
        @click.prevent="toggleResetPwdModal(true)"
      >
        重新設定密碼
      </w-button>
      <reset-password
        :open="resetPwdDialog"
        @close="toggleResetPwdModal(false)"
      />
    </div>
  </div>
</template>

<script>
import UserSecurity from './UserSecurity';

export default UserSecurity;
</script>

<style lang="scss" scoped>
@import 'UserSecurity';
</style>
